/** @jsx jsx */
import { jsx, css } from '@emotion/react';
var descriptionStyles = css({
  maxHeight: 100,
  // height is defined as 5 lines maximum by design
  overflow: 'auto',
  wordWrap: 'break-word'
});

var Description = function Description(_ref) {
  var color = _ref.color,
      testId = _ref.testId,
      children = _ref.children,
      isBold = _ref.isBold;
  return jsx("div", {
    style: {
      color: color
    },
    css: [descriptionStyles],
    "data-testid": testId
  }, children);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc


export default Description;